import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../App';
import ResponsableSidebar from '../../components/ResponsableSidebar';
import HollyChat from '../../components/HollyChat';

const ResponsabileLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(() => typeof window !== 'undefined' && window.innerWidth >= 768);
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const media = window.matchMedia('(min-width: 768px)');
    const syncSidebar = event => setSidebarOpen(event.matches);
    media.addEventListener('change', syncSidebar);
    return () => media.removeEventListener('change', syncSidebar);
  }, []);

  const handleLogout = () => {
    const isHomeSmart = !!user?.is_external_tenant;
    logout();
    navigate(isHomeSmart ? '/home-smart/accedi' : '/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <ResponsableSidebar 
        isOpen={sidebarOpen} 
        setIsOpen={setSidebarOpen} 
        onLogout={handleLogout}
      />
      <main className="flex-1 md:ml-0 overflow-auto">
        <Outlet />
      </main>
      {/* Holly Chat - AI Assistant */}
      <HollyChat isHomeSmart={!!user?.is_external_tenant} />
    </div>
  );
};

export default ResponsabileLayout;
